<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <router-view class="height-full" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Index-financing",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getScreen"]),
  },
};
</script>

<style lang="less" scoped>
</style>